/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faBriefcase} from '@fortawesome/pro-duotone-svg-icons';

const PortfolioIcon = ({icon, ...props}) => (
  <FontAwesomeIcon icon={faBriefcase} {...props} />
);

export default PortfolioIcon;
